import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-icustomer-transaction',
  templateUrl: './icustomer-transaction.component.html',
  styleUrls: ['./icustomer-transaction.component.scss']
})
export class IcustomerTransactionComponent implements OnInit {
  icustomer_code: any = null;
  icustomer_mobile: any = null;
  icustomer_verified = false;
  icustomer_detail: any;
  icustomer_id: any;
  final_price: any;
  transaction_log: any;

  constructor(private global: GlobalService, private httpService: HttpService) { 
    this.global.set_master_page_title = 'Customer Transactions';
  }

  getIcustomerDetails() {
    this.httpService.checkIcustomerDetails({ 'icustomer_number': this.icustomer_mobile, 'icustomer_code': this.icustomer_code }).subscribe((data) => {
      console.log('customer details', data);
      if (data['found']) {
        this.icustomer_verified = true;
        this.icustomer_detail = data;
        this.getTransactions(data['icustomer_id'])
      } else {
        this.icustomer_code = null;
        this.icustomer_mobile = null;
        this.icustomer_verified = false;
        alert('Customer not found!');

      }
    }, (error) => {
      console.log(error);
    });
  }
  getTransactions(icustomer_id) {
    const data_dict = {
      icustomer_id : icustomer_id,
      from: 'portal'
    }
   this.httpService.serveTransactionLogForIcustomer(data_dict).subscribe((data) => {
     console.log(data);
     this.transaction_log = data['transaction_log'];
   }, (error) => {
     console.error(error);
   });
  }
  ngOnInit() {
  }

}
